module.exports = __webpack_public_path__ + "media/images/broniec 2-5d697e6d10c130759f21c292f18ce31b.jpg";